import {ObjectStoreMeta} from "ngx-indexed-db";
import { DagreNodesOnlySettings, Orientation } from "./graph-kn.cm-api-models";
import { EdgePointerType, EEdgyType, ELayoutAlgorithms } from "./graph-kn.model-enums";

export const SETTING_STORAGE = 'graph_settings'
export const graphStoreConfig: ObjectStoreMeta = {
    store: 'graph_settings',
    storeConfig: {keyPath: 'setting_id', autoIncrement: true},
    storeSchema: [
        {name: 'setting_id', keypath: 'setting_id', options: {unique: true}},
        {name: 'setting_value', keypath: 'setting_value', options: {unique: true}},
    ],
}
export const graphDefaultSettings : DagreNodesOnlySettings = {
    module:ELayoutAlgorithms.Darge,
	ranker: 'network-simplex',
    algorithmEdges:ELayoutAlgorithms.Local,
	edgeType: EEdgyType.Dagre,
	pointerType:EdgePointerType.Arrow,
	orientation: Orientation.LEFT_TO_RIGHT,
	rankPadding: 80,
	nodePadding: 100,
}
export const LONG_TAP_DURATION = 1000;
export const SCALE_BY = 1.01;
export const CONTRACT_BP_RATIO_HEIGHT = 1;
export const CONTRACT_TASK_RATIO_HEIGHT = 1;
export const CONTRACT_BP_RATIO_WIDTH = 1;
export const MIN_NODES_ROW_PADDING = 30

// PARENT
export const PARENT_LABEL_OFFSET_Y = -5
export const PARENT_PADDING = 10
export const PARENT_CHILD_GAP = 30

export const ROLES_NAMES = {
    executor: 'EXECUTORS',
    observer: 'OBSERVERS',
    responsible: 'RESPONSIBLE',
}
export const TARGET_TYPES_WITH_RESTRICTIONS = ['payment', 'credit_letter', 'multi_payment']
export const TARGET_TYPES_ONLY_VIEW = ['credit_letter']